export const isMlsRestrictedTenant = (tenant) => {
  if (!tenant) return false;
  return Boolean(
    tenant.mlsRestricted ||
      tenant.auth?.requiresLogin ||
      tenant.auth?.saml?.enabled,
  );
};

// Cache for non-React callers; AppConfigProvider primes it at boot.
// `undefined` = unprimed (distinct from `null` = primed, non-BLS).
let cachedTenant = undefined;
export const setCachedTenant = (tenant) => {
  cachedTenant = tenant;
};
export const getCachedTenant = () => cachedTenant;
export const isTenantPrimed = () => cachedTenant !== undefined;
export const isCurrentTenantMlsRestricted = () =>
  isMlsRestrictedTenant(cachedTenant);
